module.exports = __webpack_public_path__ + "img/Email.d01b40ad.svg";